export const FETCH_PRODUCTS_SUCCESS = "FETCH_PRODUCTS_SUCCESS";
export const FETCH_PRODUCTS_ERROR = "FETCH_PRODUCTS_ERROR";
export const ADD_REVIEW_TO_PRODUCT = "ADD_REVIEW_TO_PRODUCT";
export const REFRESH_PRODUCT_VARIATION = "REFRESH_PRODUCT_VARIATION";
const initState = {
  products: [],
};

export const addReviewToProducts = (review, idArt) => {
  //console.log(review);
  review.id = idArt;
  return (dispatch) => {
    dispatch({ type: ADD_REVIEW_TO_PRODUCT, payload: review });
  };
};

export const fetchProducts = async (credentials) => {
  //return {Errore: '', items: [], personal : {IDAge: 0, IDCli: 41917, TipLis: 0, S1: 0, S2: 0, IDLis: 32}};

  //console.log("fetch " + JSON.stringify(credentials))
  var body = JSON.stringify(credentials);
  const { recommended } = credentials;
  credentials.recommended = "";

  var endpoint = global.endpoint + "pegaso/getProducts";
  return fetch(endpoint, {
    method: "POST",
    headers: new Headers({
      "Content-Type": "application/x-www-form-urlencoded",
    }),
    body: body,
    withCredentials: false,
  })
    .then((res) => res.json())
    .then((result) => {
      if (!result.items) {
        try {
          const itemsFromAPI = JSON.parse(result?.itemsNoParsed);
          var recommendedProducts = !recommended
            ? undefined
            : recommended
                .map(
                  (_r) =>
                    itemsFromAPI?.find((_item) => _item.id === _r.idArtBas) ||
                    null
                )
                .filter((_rr) => !!_rr?.id);
          if (recommendedProducts)
            recommendedProducts = recommendedProducts.map((_r) => {
              _r.recommended = true;
              return _r;
            });
          const itemsFromAPINorecomended = !recommended
            ? itemsFromAPI
            : itemsFromAPI.filter(
                (_i) => !recommended.find((_r) => _r.idArtBas === _i.id)
              );
          result.items = !recommended
            ? [...itemsFromAPI]
            : [...recommendedProducts, ...itemsFromAPINorecomended];
          result.items = result.items.reduce((acc, current) => {
            if (!acc.some((item) => item.id === current.id)) {
              acc.push(current);
            }
            return acc;
          }, []);
          result.itemsNoParsed = "";
          result.itemsDescription = JSON.parse(
            result?.itemsDescriptionNoParsed
          );
          result.itemsDescriptionNoParsed = "";
          result.itemsNoSco = JSON.parse(
            result.itemsNoSco ? result.itemsNoSco : "[]"
          );
        } catch (error) {
          console.log(error);
        }
      }
      sessionStorage.setItem("lastRefresh", Date.now());
      console.log(result);
      return result;
    });
};
export const fetchProductsNoResult = (credentials) => {
  //console.log("fetch " + JSON.stringify(credentials))
  var body = JSON.stringify(credentials);

  var endpoint = global.endpoint + "pegaso/getProducts";
  return fetch(endpoint, {
    method: "POST",
    headers: new Headers({
      "Content-Type": "application/x-www-form-urlencoded",
    }),
    body: body,
    withCredentials: false,
  });
};

export const clearProducts = () => {
  return (dispatch) => {
    dispatch({ type: FETCH_PRODUCTS_SUCCESS, payload: initState });
  };
};

export const saveProducts = (products, addToast) => {
  return (dispatch) => {
    var prodottiRestituiti = products.items;
    var descrizioni = products.itemsDescription;
    var itemsNoSco = products.itemsNoSco;
    if (products.personal && products.personal.TipLis == 4) {
      //console.log(JSON.stringify(prodottiRestituiti))
      prodottiRestituiti = refreshPrice(
        prodottiRestituiti,
        products.personal,
        itemsNoSco
      );
    }
    if (products.condizioni?.length > 0)
      prodottiRestituiti = applicaCondizioniParticolariNew(
        prodottiRestituiti,
        products.condizioni,
        products.personal,
        itemsNoSco
      );
    if (products.ultimiPrezzi?.length > 0)
      prodottiRestituiti = applicaUltimiPrezzi(
        prodottiRestituiti,
        products.ultimiPrezzi
      );
    if (global.aziendaID === 1)
      prodottiRestituiti = aggiustaNomiImmagini(prodottiRestituiti);
    if (global.aziendaID === 4) {
      prodottiRestituiti = aggiustaCodiciAlternativi(prodottiRestituiti);
    }
    sessionStorage.setItem("personal", JSON.stringify(products.personal));
    sessionStorage.setItem("condizioni", JSON.stringify(products.condizioni));
    sessionStorage.setItem("itemsNoSco", JSON.stringify(products.itemsNoSco));

    if (prodottiRestituiti) {
      dispatch({
        type: FETCH_PRODUCTS_SUCCESS,
        payload: prodottiRestituiti,
        payload2: descrizioni,
      });
      //addToast("Prodotti Caricati", { appearance: "success", autoDismiss: true, placement: 'bottom-left' });
    } else {
      dispatch({
        type: FETCH_PRODUCTS_ERROR,
        payload: prodottiRestituiti,
        payload2: descrizioni,
      });
      //addToast("Nome Utente o Password non Valida", { appearance: "error", autoDismiss: true, placement: 'bottom-left' });
    }
  };
};
export const saveProductsWithoutToast = (products) => {
  return (dispatch) => {
    var prodottiRestituiti = products.items;
    var descrizioni = products.itemsDescription;
    var itemsNoSco = products.itemsNoSco;
    if (products.personal && products.personal.TipLis == 4) {
      //console.log(JSON.stringify(prodottiRestituiti))
      prodottiRestituiti = refreshPrice(
        prodottiRestituiti,
        products.personal,
        itemsNoSco
      );
    }
    if (products.condizioni?.length > 0)
      prodottiRestituiti = applicaCondizioniParticolariNew(
        prodottiRestituiti,
        products.condizioni,
        products.personal,
        itemsNoSco
      );
    if (products.ultimiPrezzi?.length > 0)
      prodottiRestituiti = applicaUltimiPrezzi(
        prodottiRestituiti,
        products.ultimiPrezzi
      );
    if (global.aziendaID === 1)
      prodottiRestituiti = aggiustaNomiImmagini(prodottiRestituiti);
    if (global.aziendaID === 4) {
      prodottiRestituiti = aggiustaCodiciAlternativi(prodottiRestituiti);
    }
    sessionStorage.setItem("personal", JSON.stringify(products.personal));
    sessionStorage.setItem("condizioni", JSON.stringify(products.condizioni));
    sessionStorage.setItem("itemsNoSco", JSON.stringify(products.itemsNoSco));

    if (prodottiRestituiti) {
      dispatch({
        type: FETCH_PRODUCTS_SUCCESS,
        payload: prodottiRestituiti,
        payload2: descrizioni,
      });
      //addToast("Prodotti Caricati", {appearance: "success", autoDismiss: true, placement: 'bottom-left' });
    } else {
      dispatch({
        type: FETCH_PRODUCTS_ERROR,
        payload: prodottiRestituiti,
        payload2: descrizioni,
      });
      //addToast("Nome Utente o Password non Valida", {appearance: "error", autoDismiss: true, placement: 'bottom-left' });
    }
  };
};
export const refreshVariation = async (variations) => {
  return (dispatch) => {
    //console.log("dentro la dispatch")
    dispatch({ type: REFRESH_PRODUCT_VARIATION, payload: variations });
  };
};
export const refreshPrice = (products, personal, productNoSco) => {
  return products.map((product) => {
    //console.log(product)
    if (productNoSco?.find((p) => p.IDArtBas === product.id)) {
      return product;
    }
    if (product.variation) {
      return {
        ...product,
        variation: product.variation?.map((variation) => {
          return {
            ...variation,
            size: variation.size?.map((size) => {
              return {
                ...size,
                priceOld: size.preLis ? size.preLis : size.pricesco,
                pricesco: size.pricesco,
              };
            }),
          };
        }),
      };
    } else return product;
  });
};

export const applicaUltimiPrezzi = (products, ultimiPrezzi) => {
  if (!products) return [];
  return products.map((product) => {
    if (product.variation?.length > 0) {
      return {
        ...product,
        variation: product.variation?.map((variation) => {
          return {
            ...variation,
            size: variation.size?.map((size) => {
              var IDArt = size.IDArtSizeColor;
              var ultimoPrezzo = ultimiPrezzi.find(
                (cond) => cond.IDART == IDArt
              );
              if (ultimoPrezzo) {
                var priceSco = ultimoPrezzo.ULTPRE;
                return {
                  ...size,
                  priceOld: size.priceOld ? size.priceOld : size.pricesco,
                  pricesco: priceSco,
                };
              }
              return { ...size, pricesco: size.pricesco };
            }),
          };
        }),
      };
    } else {
      var ultimoPrezzo = ultimiPrezzi.find((cond) => cond.IDART == product.id);
      if (ultimoPrezzo) {
        product.price = ultimoPrezzo.ULTPRE;
        product.pricesco = ultimoPrezzo.ULTPRE;
      }
      return product;
    }
  });
};
export const aggiustaNomiImmagini = (products) => {
  if (!products) return [];
  if (global.aziendaID === 4) {
    return products;
  }
  return products.map((product) => {
    if (product.image.length > 0) {
      for (var i = 0; i < product.image.length; i++) {
        product.image[i] =
          product.sku +
          (i > 0 ? "-" + i : "") +
          "." +
          product.image[i].split(".")[product.image[i].split(".").length - 1];
      }
      product.image = product.image.sort();
      const lastElement = product.image.pop();
      product.image.unshift(lastElement);
    }

    return product;
  });
};

export const aggiustaCodiciAlternativi = (products) => {
  if (!products) return [];
  return products.map((product) => {
    if (product.altdat1 && product.altdat1.length > 0) {
      product.codiciAlternativi = JSON.parse(product.altdat1);
      product.altdat1 = null;
    }
    return product;
  });
};
export const applicaCondizioniParticolariNew = (
  products,
  condizioni,
  personal,
  productNoSco
) => {
  return products.map((product) => {
    if (product.variation.length > 0) {
      return {
        ...product,
        variation: product.variation?.map((variation) => {
          return {
            ...variation,
            size: variation.size?.map((size) => {
              var IDArt = size.IDArtSizeColor;
              var condizione = condizioni.find((cond) => cond.IDArt == IDArt);
              var noScontoRapporto = false;
              if (productNoSco?.find((p) => p.IDArtBas === product.id)) {
                noScontoRapporto = true;
              }
              if (condizione) {
                var priceScoCondizione =
                  condizione.Pre > 0
                    ? condizione.Pre
                    : size.preLis * (1 - condizione.Sco / 100.0);
                var priceScoRapporto = noScontoRapporto
                  ? size.preLis
                  : size.preLis *
                    (1 - personal.S1 / 100.0) *
                    (1 - personal.S2 / 100.0);
                var priceScoListino = size.pricesco;
                var priceListino = size.preLis;
                var prezzoMin = Math.min(
                  priceScoCondizione,
                  priceScoRapporto,
                  priceScoListino,
                  priceListino
                );
                var prezzoMax = Math.max(
                  priceScoCondizione,
                  priceScoRapporto,
                  priceScoListino,
                  priceListino
                );
                return { ...size, priceOld: prezzoMax, pricesco: prezzoMin };
              } else {
                if (noScontoRapporto) {
                  return { ...size, pricesco: size.pricesco };
                }
                var priceScoRapporto =
                  size.preLis *
                  (1 - personal.S1 / 100.0) *
                  (1 - personal.S2 / 100.0);
                var priceScoListino = size.pricesco;
                var priceListino = size.preLis;

                var prezzoMin = Math.min(
                  priceScoRapporto,
                  priceScoListino,
                  priceListino
                );
                var prezzoMax = Math.max(
                  priceScoRapporto,
                  priceScoListino,
                  priceListino
                );
                return { ...size, priceOld: prezzoMax, pricesco: prezzoMin };
              }
            }),
          };
        }),
      };
    } else if (global.aziendaID == 4) {
      var IDArt = product.id;
      var condizioniTrovate = condizioni.filter((cond) => cond.IDArt == IDArt);
      var priceSco = product.pricesco;
      var prezzoMin = product.pricesco;
      condizioniTrovate.forEach((condizione) => {
        if (condizione) {
          prezzoMin =
            condizione.Pre > 0 && condizione.Pre < prezzoMin
              ? condizione.Pre
              : prezzoMin * (1 - condizione.Sco / 100.0);
        }
      });
      return { ...product, priceOld: priceSco, pricesco: prezzoMin };
    } else return product;
  });
};
export const applicaCondizioniParticolari = (products, condizioni) => {
  return products.map((product) => {
    if (product.variation) {
      return {
        ...product,
        variation: product.variation?.map((variation) => {
          return {
            ...variation,
            size: variation.size?.map((size) => {
              var IDArt = size.IDArtSizeColor;
              var condizione = condizioni.find((cond) => cond.IDArt == IDArt);
              if (condizione) {
                var priceSco = size.pricesco * (1 - condizione.Sco / 100.0);
                if (size.priceOld > 0) {
                  //ho calcolato la scontistica sul cliente esiste priceOld
                  //se lo sconto sulla condizione è maggiore dello sconto sul cliente (quindi pricesco calcolato precedentemente)
                  priceSco =
                    size.priceOld * (1 - condizione.Sco / 100.0) > size.pricesco
                      ? size.pricesco
                      : size.priceOld * (1 - condizione.Sco / 100.0);
                }
                if (priceSco > condizione.Pre && condizione.Pre > 0)
                  priceSco = condizione.Pre;
                if (size.pricesco > priceSco)
                  return {
                    ...size,
                    priceOld: size.priceOld ? size.priceOld : size.pricesco,
                    pricesco: priceSco,
                  };
              }
              return { ...size, pricesco: size.pricesco };
            }),
          };
        }),
      };
    } else return product;
  });
};
